// Horaires d'ouverture par jour
export const OPENING_HOURS = {
  1: [{ start: '10:00', end: '12:00' }, { start: '14:00', end: '20:00' }], // Lundi
  2: [{ start: '10:00', end: '12:00' }, { start: '14:00', end: '20:00' }], // Mardi
  3: [{ start: '10:00', end: '12:00' }, { start: '14:00', end: '20:00' }], // Mercredi
  4: [{ start: '10:00', end: '12:00' }, { start: '14:00', end: '20:00' }], // Jeudi
  5: [{ start: '15:00', end: '21:00' }], // Vendredi
  6: [{ start: '10:00', end: '12:00' }, { start: '14:00', end: '20:00' }], // Samedi
  0: [{ start: '10:00', end: '13:00' }], // Dimanche
};

// RIB pour virement
export const RIB = 'FR76 2823 3000 0183 4674 8207 942';

// Prix des services (EXACTEMENT comme dans mockData.js)
export const SERVICE_PRICES = {
  // Revitalisation
  'Massage Nigella': { full: 40, firstVisit: 36, deposit: 15 },
  "Massage Sésame d'Orient": { full: 40, firstVisit: 36, deposit: 15 },
  'Massage Sahara': { full: 40, firstVisit: 36, deposit: 15 },
  
  // Pieds & Mains
  'Beauté des pieds': { full: 30, firstVisit: 30, deposit: 10 },
  'Beauté des mains': { full: 30, firstVisit: 30, deposit: 10 },
  
  // Mère & Fille
  'Moment détente Mère et Fille': { full: 60, firstVisit: 60, deposit: 30 },
  
  // Femme Enceinte
  'Massage Prénatal': { full: 60, firstVisit: 54, deposit: 20 },
  'Massage Postnatal': { full: 60, firstVisit: 54, deposit: 20 },
  'Massage Postnatal + serrage de bassin': { full: 45, firstVisit: 40, deposit: 15 },
  
  // Détente
  'Massage Signature MEYA': { full: 45, firstVisit: 40, deposit: 15 },
  'Massage Amna': { full: 45, firstVisit: 40, deposit: 15 },
  'Massage + drainage visage': { full: 35, firstVisit: 31, deposit: 12 },
  
  // Beauté du Regard
  'Rehaussement de cils': { full: 25, firstVisit: 25, deposit: 10 },
  'Restructuration des sourcils (avec décolo + teinture)': { full: 35, firstVisit: 35, deposit: 12 },
  'Restructuration des sourcils (avec décolo sans teinture)': { full: 25, firstVisit: 25, deposit: 10 },
  'Pack Complet Beauté du Regard': { full: 45, firstVisit: 45, deposit: 15 },
  'Browlift avec teinture': { full: 25, firstVisit: 25, deposit: 10 },
  'Browlift sans teinture': { full: 20, firstVisit: 20, deposit: 8 },
  
  // Anniversaire
  'Anniversaire Mini Spa': { full: 25, firstVisit: 25, deposit: 25 },
  'Anniversaire Deluxe Spa': { full: 50, firstVisit: 50, deposit: 30 },
  'Anniversaire Luxury Spa': { full: 90, firstVisit: 90, deposit: 30 },
};

// Générer les créneaux horaires selon les horaires d'ouverture
export const generateTimeSlots = (date) => {
  const dayOfWeek = date.getDay();
  const hours = OPENING_HOURS[dayOfWeek];
  
  if (!hours) return [];
  
  const slots = [];
  
  hours.forEach(period => {
    const [startHour, startMin] = period.start.split(':').map(Number);
    const [endHour, endMin] = period.end.split(':').map(Number);
    
    let currentHour = startHour;
    let currentMin = startMin;
    
    while (currentHour < endHour || (currentHour === endHour && currentMin < endMin)) {
      const timeStr = `${currentHour.toString().padStart(2, '0')}:${currentMin.toString().padStart(2, '0')}`;
      slots.push(timeStr);
      
      // Incrémenter de 30 minutes
      currentMin += 30;
      if (currentMin >= 60) {
        currentMin = 0;
        currentHour += 1;
      }
    }
  });
  
  return slots;
};
